import React from 'react';
import { ScarcityBanner } from '../components/ScarcityBanner';
import { HeroLP5 } from '../components/HeroLP5';
import { Testimonial } from '../components/Testimonial';
import { ProblemSolutionLP4 } from '../components/ProblemSolutionLP4';
import { ValueStackLP4 } from '../components/ValueStackLP4';
import { ModuleBreakdown } from '../components/ModuleBreakdown';
import { Guarantee } from '../components/Guarantee';
import { ClosingLP4 } from '../components/ClosingLP4';
import { Footer } from '../components/Footer';
import { RecentPurchaseToast } from '../components/RecentPurchaseToast';
export function LandingPageLP5() {
  return <div className="w-full min-h-screen bg-navy font-body text-white" data-id="element-1343">
      <ScarcityBanner data-id="element-1344" />
      <HeroLP5 data-id="element-1345" />
      <Testimonial data-id="element-1346" />
      <ProblemSolutionLP4 data-id="element-1347" />
      <ValueStackLP4 data-id="element-1348" />
      <ModuleBreakdown data-id="element-1349" />
      <Guarantee data-id="element-1350" />
      <ClosingLP4 data-id="element-1351" />
      <Footer data-id="element-1352" />
      <RecentPurchaseToast data-id="element-1353" />
    </div>;
}